import LocalizedStrings from "react-localization";
import EN from "./en.json";
import HR from "./hr.json";

export default new LocalizedStrings({
  en: EN,
  hr: HR
});
